import React from 'react';
import PropTypes from 'prop-types';
import DateInput from '../DateInput';
import { getIn } from 'formik';

export default function FormikDateInput({ form, name, field, ...props }) {
  const { touched, errors, setFieldValue } = form;
  const fieldError = getIn(errors, field.name);
  const showError = getIn(touched, field.name) && !!fieldError;
  return (
    <DateInput
      value={field.value}
      {...props}
      onChange={(date) => {
        form.setFieldValue(field.name, date);
      }}
      hasError={showError}
      helpText={fieldError}
    />
  );
}

FormikDateInput.propTypes = {
  form: PropTypes.object,
  name: PropTypes.string,
};
